export default function (value: number) {
  return value.toString()
}
